var _rect, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4274_6447",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 32,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4274_6447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.38477 30.4614C-5.38477 12.7883 8.94212 -1.53857 26.6152 -1.53857H57.9998C75.6729 -1.53857 89.9998 12.7883 89.9998 30.4614V57.9999C89.9998 75.673 75.673 89.9999 57.9999 89.9999H26.6153C8.94215 89.9999 -5.38477 75.673 -5.38477 57.9999V30.4614Z",
    fill: "url(#paint0_linear_4274_6447)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4274_6447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4437 25L57.3203 52.5C57.4666 52.7534 57.5436 53.0408 57.5436 53.3333C57.5436 53.6259 57.4666 53.9133 57.3203 54.1667C57.1741 54.42 56.9637 54.6304 56.7103 54.7767C56.4569 54.923 56.1695 55 55.877 55H24.1237C23.8311 55 23.5437 54.923 23.2903 54.7767C23.037 54.6304 22.8266 54.42 22.6803 54.1667C22.534 53.9133 22.457 53.6259 22.457 53.3333C22.457 53.0408 22.534 52.7534 22.6803 52.5L38.557 25C38.7033 24.7467 38.9137 24.5363 39.167 24.39C39.4204 24.2438 39.7078 24.1667 40.0003 24.1667C40.2929 24.1667 40.5803 24.2438 40.8336 24.39C41.087 24.5363 41.2974 24.7467 41.4437 25ZM38.3337 46.6667V50H41.667V46.6667H38.3337ZM38.3337 35V43.3333H41.667V35H38.3337Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4274_6447",
    x1: -3.09553,
    y1: 12.1922,
    x2: 85.2635,
    y2: 103.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD180"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4274_6447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.e0559558258899ef66dca6ccffd349ba.svg";
export { ForwardRef as ReactComponent };